export default __webpack_public_path__ + "img/cCWWUvED.a5787671.svg";